
  var show_per_page = document.getElementById('show_per_page').value;
  var blogArticles = document.querySelectorAll('.blog-articles > *');
  var number_of_items = blogArticles.length;
  var number_of_pages = Math.ceil(number_of_items / show_per_page);

  document.getElementById('current_page').value = 0;
  document.getElementById('show_per_page').value = show_per_page;

  // Build pagination HTML
  var navigation_html = '<a class="previous_link" href="javascript:previous();"><svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.88192 0.690279L1.50005 5.00005C2.59912 6.078 4.78282 8.23186 5.88192 9.30984L6.43492 8.77472C5.44622 7.80526 4.13848 6.51348 2.98468 5.38043L10.1195 5.38047L10.1195 4.61955L2.98466 4.61953L6.43491 1.23118L5.88192 0.690279Z" fill="#414141" stroke="#414141"></path></svg></a>';
  var current_link = 0;

  while (number_of_pages > current_link) {
    navigation_html += '<a class="page_link" href="javascript:go_to_page(' + current_link +')" longdesc="' + current_link +'">'+ (current_link + 1) +'</a>';
    current_link++;
  }

  navigation_html += '<a class="next_link" href="javascript:next();"><svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.11808 0.690279L9.49995 5.00005C8.40088 6.078 6.21718 8.23186 5.11808 9.30984L4.56508 8.77472C5.55378 7.80526 6.86152 6.51348 8.01532 5.38043L0.880466 5.38047L0.880463 4.61955L8.01534 4.61953L4.56509 1.23118L5.11808 0.690279Z" fill="#414141" stroke="#414141"></path></svg></a>';
  document.getElementById('page_navigation').innerHTML = navigation_html;document.getElementById('page_navigation').innerHTML = navigation_html;

  // Set the initial active page
  if (number_of_pages > 0) {
    document.querySelectorAll('#page_navigation .page_link')[0].classList.add('active_page');
  }

  // Hide all articles initially, then show the first "page" of items
  Array.from(blogArticles).forEach(function (item, index) {
    item.style.display = index < show_per_page ? 'block' : 'none';
  });

  // =========================
  //  updateLinksState()
  // =========================
  function updateLinksState() {
    var current_page = parseInt(document.getElementById('current_page').value, 10);
    var prevLink = document.querySelector('.previous_link');
    var nextLink = document.querySelector('.next_link');

    // If there's only one page total, disable both links
    if (number_of_pages === 1) {
      prevLink.classList.add('disabled');
      nextLink.classList.add('disabled');
      return; 
    }

    // Otherwise, enable/disable based on current page:
    // Disable "Previous" if on page 0
    if (current_page === 0) {
      prevLink.classList.add('disabled');
    } else {
      prevLink.classList.remove('disabled');
    }

    // Disable "Next" if on the last page
    if (current_page === number_of_pages - 1) {
      nextLink.classList.add('disabled');
    } else {
      nextLink.classList.remove('disabled');
    }
  }

  // Run updateLinksState for the initial page
  updateLinksState();

  // =========================
  //  Pagination Functions
  // =========================
  function previous() {
    var current_page = parseInt(document.getElementById('current_page').value, 10);
    if (current_page > 0) {
      go_to_page(current_page - 1);
    }
  }

  function next() {
    var current_page = parseInt(document.getElementById('current_page').value, 10);
    if (current_page < number_of_pages - 1) {
      go_to_page(current_page + 1);
    }
  }

  function go_to_page(page_num) {
    var show_per_page = parseInt(document.getElementById('show_per_page').value, 10);
    var start_from = page_num * show_per_page;
    var end_on = start_from + show_per_page;

    // Hide all articles, show only the current "page" range
    Array.from(blogArticles).forEach(function (item, index) {
      item.style.display = (index >= start_from && index < end_on) ? 'block' : 'none';
    });

    // Update active page link
    document.querySelectorAll('.page_link').forEach(function (link) {
      link.classList.remove('active_page');
    });
    document.querySelector('.page_link[longdesc="' + page_num + '"]').classList.add('active_page');

    // Scroll up to the top of the blog area (optional)
    document.querySelector('.main-blog').scrollIntoView({ behavior: 'smooth' });

    // Update our hidden current_page value
    document.getElementById('current_page').value = page_num;

    // Check and update button states
    updateLinksState();
  }